import Vue from "vue";
import { mapGetters, mapMutations } from "vuex";
import { Tabs, Tab } from "vue-slim-tabs";
import { VueSlideToggle } from "vue-slide-toggle";
import listItem from "./components/list-item/index.vue";
import CategoryItem from "@/components/catalog-list/components/category-item/index.vue";

export default {
    name: "catalog-list",
    props: ["list", "currentItem"],
    data() {
        return {
            openChilds: false,
            positionScroll: 0,
            isMounted: false,
            maxValue: null,
            currentId: 28,
            test: this.list,
            isActive: true,
        };
    },
    components: {
        Tabs,
        Tab,
        VueSlideToggle,
        "catalog-list-item": listItem,
        CategoryItem,
    },
    computed: {
        ...mapGetters({
            showCatalogMenu: "system/showCatalogMenu",
            robots: "system/robots",
        }),
        getFirstCategoryId() {
            // console.log(this)
        },
        childList() {
            for (let i in this.list) {
                if (this.currentId === this.list[i].id) {
                    return this.list[i].childs;
                }
            }
        },
        // disableLeft() {
        //   return this.positionScroll > 0
        // },
        // disableRight() {
        //   return this.positionScroll < this.maxValue;
        // },
    },
    created() {},
    mounted() {
        // let element = document.getElementsByClassName('vue-tablist')[0];
        // this.maxValue = element.scrollWidth - element.offsetWidth;
        this.test2();
    },
    methods: {
        ...mapMutations({
            changeShowCatalogMenu: `system/CHANGE_SHOW_CATALOG_MENU`,
        }),
        test2() {
            for (let key in this.test) {
                return (this.currentId = this.test[key].id);
            }
        },
        navigateTo(slug) {
            console.log("gyguygy");
            this.$router.push({ name: "category-page" }).catch(() => {
                console.log("");
            });
        },
        // changeShowCatalog() {
        //     if (this.showCatalogMenu) {
        //         this.changeShowCatalogMenu(false);
        //     } else {
        //         this.changeShowCatalogMenu(true);
        //     }
        // },
        changeSubMenu(item) {
            this.$router
                .push({ name: "category-page", params: { lang: this.$route.params.lang, categorySlug: item.slug } })
                .catch(() => {
                    console.log("");
                });
            this.isActive = !this.isActive;
        },
        hover(event) {
            this.currentId = parseInt(event.target.getAttribute("data-id"));
            this.isActive = !this.isActive;
        },
        test7(event) {
            // this.$router.push({name: 'sub-category'}).catch(() => {
            //             console.log();
            //           });
            console.log("no empty");
            event.stopPropagation();
        },
        logHover() {
            // console.log('123')
        },
        // scrollLeft() {
        //   let element = document.getElementsByClassName('vue-tablist')[0];
        //   if (this.positionScroll > 0) {
        //     element.scrollLeft = this.positionScroll -= 50;
        //   }
        // },
        // scrollRight() {
        //   let element = document.getElementsByClassName('vue-tablist')[0];
        //   if (this.positionScroll < element.scrollWidth - element.offsetWidth) {
        //     element.scrollLeft = this.positionScroll += 50;
        //   }
        // },
        // scrollCatalogHeader(event) {
        //   this.positionScroll = event.target.scrollTop;
        // }
    },
};
